module.exports = __webpack_public_path__ + "img/user.e97a89e8.png";